<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.user_id"
        placeholder="请输入用户ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.nickname"
        placeholder="请输入姓名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.title"
        placeholder="请输入标题"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.content"
        placeholder="请输入内容"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_on"
        placeholder="状态"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="已下架" :value="0" />
      </el-select>
      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="头像" min-width="110" align="center">
        <template slot-scope="scope">
          <el-image
            style="height: 60px"
            :preview-src-list="[scope.row.user.avatar]"
            :src="scope.row.user.avatar"
            class="banner-image"
            lazy
          />
        </template>
      </el-table-column>
      <el-table-column label="姓名" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.user.nickname }} </template>
      </el-table-column>
      <el-table-column label="标题" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.title }} </template>
      </el-table-column>
      <el-table-column label="内容" min-width="110" align="center">
        <template slot-scope="scope">
          <div class="overflow">
            {{ scope.row.content }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="评论人数" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.comment_num }} </template>
      </el-table-column>
      <el-table-column label="点赞人数" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.like_num }} </template>
      </el-table-column>
      <el-table-column label="置顶状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.top_status == 1" type="success">已置顶</el-tag>
          <el-tag v-else type="danger">未置顶</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on == 1" type="success">正常</el-tag>
          <el-tag v-else type="danger">已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleCheckDetail(scope.row)"
            >查看详情</el-button
          >
          <el-button size="mini" v-if="scope.row.top_status == 0" type="success" @click="handleTop(scope.row)">
            置顶
          </el-button>
          <el-button size="mini" v-else type="danger" @click="handleTop(scope.row)">
            取消置顶
          </el-button>
          <el-button
            v-if="scope.row.is_on == 1"
            size="mini"
            type="danger"
            @click="handleStatus(scope.row.id, '下架')"
            >下架</el-button
          >
          <el-button
            v-else
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, '上架')"
            >上架</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="查看详情"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" label-width="120px" v-if="detail.user">
        <el-form-item label="头像:">
          <el-image
            style="height: 60px"
            :src="detail.user.avatar"
            class="banner-image"
            lazy
          />
        </el-form-item>
        <el-form-item label="姓名:">
          {{ detail.user.nickname }}
        </el-form-item>
        <el-form-item label="标题:">
          {{ detail.title }}
        </el-form-item>
        <el-form-item label="状态:">
          <el-tag type="success" v-if="detail.is_on == 1">正常</el-tag>
          <el-tag type="success" v-else>已下架</el-tag>
        </el-form-item>
        <el-form-item label="评论人数:">
          {{ detail.comment_num }}
        </el-form-item>
        <el-form-item label="点赞人数:">
          {{ detail.like_num }}
        </el-form-item>
        <el-form-item label="内容:">
          {{ detail.content }}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: "",
        nickname: "",
        title: "",
        content: "",
        is_on: "",
      },
      dialogFormVisible: false,
      form: {
        id: "",
        name: "",
      },
      rules: {
        name: [
          { required: true, message: "院系不能为空", trigger: "change" },
        ],
      },
      btnLoading: false,
      detail: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/post/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    getDetail(id) {
      request({
        url: "/api/backend/post/detail",
        method: "get",
        params: { id },
      }).then((response) => {
        this.detail = response.data;
        console.log(this.detail, "====================");
      });
    },
    handleTop(row) {
      request({
        url: "/api/backend/post/top",
        method: "post",
        params: { id: row.id },
      }).then((response) => {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.getList();
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        name: "",
      };
    },
    handleCheckDetail(row) {
      // this.resetForm();
      // this.form = Object.assign({}, row);
      // this.$nextTick(() => {
      //   this.$refs["form"].clearValidate();
      // });
      this.dialogFormVisible = true;
      this.getDetail(row.id);
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/course/lecturerStore",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该帖子, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/post/upDown",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.overflow {
  width: 110px;
  // height: 60px;
  overflow: hidden;
  // 下面是显示几行写数字几就行
  -webkit-line-clamp: 4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
</style>